









import Vue from 'vue';
export default Vue.extend({
  data(): { enableHover: boolean; selected: boolean } {
    return {
      enableHover: false,
      selected: false,
    };
  },
  methods: {
    onClickGNBNavigationButton(e: Event): void {
      e.stopPropagation();

      const navigationElement = (e.target as HTMLDivElement).closest(
        '.margin',
      ) as HTMLElement;
      if (navigationElement === null) {
        return;
      }

      const navigationLocation = navigationElement.dataset.location;
      const navigationIndex = parseInt(
        navigationElement.dataset.index as string,
      );

      this.$emit('onClickGNBNavigationButton', {
        navigationLocation,
        navigationIndex,
      });
    },
  },
});
